/* unplugin-vue-components disabled */import { render } from "./collection.vue?vue&type=template&id=6c2eb6b6&scoped=true&ts=true"
import script from "./collection.vue?vue&type=script&lang=ts"
export * from "./collection.vue?vue&type=script&lang=ts"

import "./collection.vue?vue&type=style&index=0&id=6c2eb6b6&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2eb6b6"]])

export default __exports__